import { useEffect } from "react";
import { motion } from "framer-motion";
import { X } from "lucide-react";
import { useLang } from "../i18n/i18n";

const VIDEOS = { fr: "/tutoriel-instagoldcalc.mp4", es: "/tutoriel-instagoldcalc-es.mp4", en: "/tutoriel-instagoldcalc-en.mp4" };

export default function TutorialModal({ onClose }) {
  const { lang, t } = useLang();
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.25 }}
      onClick={onClose}
      className="fixed inset-0 z-[100] flex items-center justify-center bg-ink/85 backdrop-blur-md p-4"
      data-testid="tutorial-modal-backdrop"
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.92, y: 24 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.95, y: 12 }}
        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
        onClick={(e) => e.stopPropagation()}
        className="relative inline-block max-w-full"
        data-testid="tutorial-modal"
      >
        <button
          onClick={onClose}
          aria-label={t("common.close")}
          data-testid="tutorial-modal-close"
          className="absolute -top-12 right-0 inline-flex h-10 w-10 items-center justify-center rounded-full border border-cream/25 text-cream/80 transition-all hover:border-gold hover:text-gold"
        >
          <X size={18} />
        </button>
        <video
          src={VIDEOS[lang] || VIDEOS.fr}
          controls
          autoPlay
          playsInline
          data-testid="tutorial-video"
          className="mx-auto block h-[70vh] w-auto aspect-[9/16] max-w-full rounded-2xl border border-gold/25 bg-ink shadow-[0_30px_90px_rgba(0,0,0,0.6)]"
        />
      </motion.div>
    </motion.div>
  );
}
